module.exports = __webpack_public_path__ + "static/img/adv_icon6.b1d67a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/adv_icon6.png
// module id = E5h2
// module chunks = 1